/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Ref, UnwrapRef, watch, toRef,
} from '@nuxtjs/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import { BloczekMarker } from '~/components/map/types/marker/BloczekMarker';
import IMarkersInnerState from '~/components/map/types/markersInnerState';

import setActiveMarker from '../../shared/setActiveMarker';

const { useState } = createNamespacedHelpers('szukaj');

const shoudIncludeInMarkersArray = (marker: BloczekMarker): boolean => marker
  && marker.DlugoscGeo !== undefined
  && marker.DlugoscGeo != null
  && marker.SzerokoscGeo !== undefined
  && marker.SzerokoscGeo != null;
const filterMarkersWithoutPosition = (markers: BloczekMarker[]): BloczekMarker[] => markers.filter((marker: BloczekMarker) => shoudIncludeInMarkersArray(marker));

const fetchMarkersFromStore = (markersInnerState: UnwrapRef<IMarkersInnerState<BloczekMarker>>): void => {
  const { wyniki: markersFromStore } = useState(['wyniki']) as { wyniki: Ref<BloczekMarker[]> };

  watch(
    markersFromStore,
    (newValue) => {
      markersInnerState.markers = filterMarkersWithoutPosition(markersFromStore.value ? markersFromStore.value : []);
    },
    { immediate: true },
  );
};
export default fetchMarkersFromStore;
